import { AdditionalDomainsType } from '../core/types';

const additionalDomains = {
  invest_real_estate: {
    name: 'invest_real_estate',
    slider: false,
  },
  maintain_standard_of_living: {
    name: 'maintain_standard_of_living',
    slider: false,
  },
};

export const getAdditionalDomains = (
  configAdditionalDomains: AdditionalDomainsType['name'][],
) =>
  configAdditionalDomains.map(
    (additionalDomain: AdditionalDomainsType['name']) =>
      additionalDomains[additionalDomain],
  );
